import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import "./CSS/Su_Depoları.css";
import "./CSS/Pumps.css";
import Store from "../Store/Store";
import {
  set_water_storage,
  SET_FETCH_TAG_VALUE_CONTROL,
  set_external_trend_info,
} from "../Action/Action";
import su_tank from "../Assets/pngegg.png";

let state_2 = [
  {
    "KAZAN DAİRESİ SU BASKIN İZLEMESİ ": [
      { text: "ALARM 1", tagId: "103", class: "su-baskin" },
      { text: "ALARM 2", tagId: "104", class: "su-baskin" },
    ],
  },
  {
    "DEPO 1": [{ text: "Depo_1", tagId: "62" }],
  },
];

const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  state_2.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/su_depolari") {
        try {
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              method: "POST",
              body: JSON.stringify(obj2__),
            }
          );
          const response = await request.json();

          const roundedResponse = response.map((item) => ({
            ...item,
            tag_value: parseFloat(item.tag_value).toFixed(2),
          }));

          Store.dispatch(set_water_storage(roundedResponse));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 10000);
};

setTimeout(() => {
  inital_func();
}, 1000);

const Su_Depoları = (props) => {
  const [depo1, Set_depo1] = useState([]);
  const [depo2, Set_depo2] = useState([]);

  const [state, Setstate] = useState(state_2);

  const history = useHistory();

  useEffect(() => {
    var newdata1 = [];
    var newdata2 = [];
    props.su_depos.forEach((x, index) => {
      console.log(x, props.su_depos);
      if (index > 1) {
        var değer = x.tagValue;
        if (değer.includes("-")) {
          değer = değer.slice(1);
        }
        değer = değer.replaceAll(",", ".");
        değer = Number(değer).toFixed(2);

        Set_progress_1(Number(değer));

        newdata1.push(x);
        Set_depo1(newdata1);
      }
    });
  }, [props.su_depos]);

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const [progress1, Set_progress_1] = useState(0);
  const [progress2, Set_progress_2] = useState(0);
  const [value, setValue] = useState(progress1);

  useEffect(() => {
    console.log(progress1);
    setValue(progress1);
  }, [progress1]);

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <section
        style={{ backgroundColor: "rgb(240,240,240)" }}
        className="water_storage"
      >
        <Link to="/">
          <Button
            style={{
              position: "absolute",
              color: "black",
              top: "12%",
              left: "18%",
              zIndex: 9999999,
              borderRadius: "15px",
              backgroundColor: "#fff",
              border: "3px solid rgba(238, 200, 108, 0.99)",
              fontWeight: 600,
            }}
            className=" movebuttons"
            variant="contained"
          >
            Geri
          </Button>
        </Link>
        <div className="bottom_pumps">
          {state.map((item, index) => {
            if (index < 1) {
              var title = [];
              var obj_ = [];
              Object.entries(item).forEach((a) => {
                title.push(a[0]);
                obj_.push(a[1]);
              });

              console.log(obj_);
              return (
                <div style={{ backgroundColor: "white" }} className="rows">
                  <div className="left">
                    <div></div>
                    <div className="lefttitle">{title[0]}</div>
                  </div>
                  <div className="right">
                    <div className="right_top">
                      {obj_[0].map((x, index) => {
                        if (x.text !== "Depo_1") {
                          const className =
                            x.text === ""
                              ? "pumpsdisplayNone"
                              : `${x.class} righttop`;
                          return (
                            <div className={x.class + " " + className}>
                              {x.text !== "" ? x.text : ""}
                            </div>
                          );
                        }
                      })}
                    </div>
                    <div className="right_bottom">
                      {obj_[0].map((x, index) => {
                        if (x.text !== "Depo_1") {
                          var değerler = props.su_depos
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);
                          var değerler_eleman = değerler[0];

                          function sondanIlkBoslukIndexiniBul(metin) {
                            if (metin !== undefined) {
                              var tersMetin = metin
                                .split("")
                                .reverse()
                                .join("");

                              var ilkBoslukIndex = tersMetin.indexOf(" ");
                              var orijinalIndex =
                                metin.length - 1 - ilkBoslukIndex;

                              return orijinalIndex;
                            }
                          }

                          function metniIndexeKadarAl(metin, index) {
                            if (metin !== undefined) {
                              var metinSubstring = metin.substring(0, index);

                              metinSubstring = String(metinSubstring);
                              metinSubstring = metinSubstring.replaceAll(
                                ",",
                                "."
                              );

                              metinSubstring =
                                Number(metinSubstring).toFixed(2);

                              return metinSubstring;
                            }
                          }

                          function sondanIlkBosluktanSonrakiKisim(metin) {
                            if (metin !== undefined) {
                              var tersMetin = metin
                                .split("")
                                .reverse()
                                .join("");

                              var ilkBoslukIndex = tersMetin.indexOf(" ");
                              var orijinalIndex =
                                metin.length - 1 - ilkBoslukIndex;

                              var sonrakiKisim = metin.substring(
                                orijinalIndex + 1
                              );

                              return sonrakiKisim;
                            }
                          }
                          var last_değer =
                            metniIndexeKadarAl(
                              değerler_eleman,
                              sondanIlkBoslukIndexiniBul(değerler_eleman)
                            ) +
                            " " +
                            sondanIlkBosluktanSonrakiKisim(değerler_eleman);
                          const matchingTag = props.tag_list.find(tag => tag.tagId === x.tagId);

                          // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                          const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null
                            ? Number(matchingTag.tagDecimal)
                            : 2;



                          last_değer = decimalPlaces !== 0 ? Number(last_değer).toFixed(decimalPlaces) : Number(last_değer).toFixed(2)
                          if (x.text.includes("Çalışma Durumu")) {
                            if (String(last_değer) === "1.00 ") {
                              last_değer = "ON";
                            } else {
                              last_değer = "OFF";
                            }
                          } else if (
                            x.text.includes("Arıza Durumu") ||
                            x.text.includes("Alarm")
                          ) {
                            if (String(last_değer) === "1.00 ") {
                              last_değer = "ALARM";
                            } else {
                              last_değer = "NORMAL";
                            }
                          }

                          return değerler.length > 0 ? (
                            değerler.map((değer) => (
                              <div
                                style={
                                  last_değer === "ALARM"
                                    ? { backgroundColor: "red", color: "white" }
                                    : {}
                                }
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];

                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;

                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  document.querySelector(
                                    ".show_external_trend"
                                  ).style.left = `${String(clientX)}px`;
                                  document.querySelector(
                                    ".show_external_trend"
                                  ).style.top = `${String(clientY)}px`;
                                }}
                                id={"pumps_gösterge_değerler_box"}
                              >
                                {last_değer}
                              </div>
                            ))
                          ) : (
                            <div style={{}}>{"Veri Yükleniyor"}</div>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </div>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "center",
          }}
          id="jdx56_id9"
        >
          <div className="progress-container">
            <span className="progress-label">Tank Seviyesi</span>
            <div
              onContextMenu={(e) => {
                e.preventDefault();
                const { clientX, clientY } = e;
                var tagName = props.tag_list
                  .filter((b) => b.tagId === "62")
                  .map((c) => c.tagName)[0];
                var popup = document.querySelector(".show_external_trend");
                document
                  .querySelector(".show_external_trend")
                  .classList.toggle("show_external_trend_active");
                document.querySelector(".show_tagId").innerHTML = "62";
                document.querySelector(".show_tagName").innerHTML = tagName;

                const popupRect = popup.getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;

                let newX = clientX;
                let newY = clientY;

                if (newX + popupRect.width > viewportWidth) {
                  newX = viewportWidth - popupRect.width;
                }

                if (newY + popupRect.height > viewportHeight) {
                  newY = viewportHeight - popupRect.height;
                }

                if (newX < 0) {
                  newX = 0;
                }

                if (newY < 0) {
                  newY = 0;
                }

                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;
              }}
              className="progress vertical"
            >
              <div
                className={`progress-bar ${value < 50 ? "red" : "yellow"}`}
                style={{ height: `${value}%` }}
              ></div>
            </div>
            <span
              style={{
                position: "relative",
                fontWeight: "600",
                fontSize: "larger",
                color: "rgb(50,50,50)",
                bottom: "10px",
                width: "100px",
                height: "30px",
                textAlign: "center",
              }}
            >
              {value.toFixed(1)} %
            </span>
          </div>
          {/* <div
            onContextMenu={(e) => {
              e.preventDefault();
              const { clientX, clientY } = e;
              var tagName = props.tag_list
                .filter((b) => b.tagId === "62")
                .map((c) => c.tagName)[0];
              var popup = document.querySelector(".show_external_trend");
              document
                .querySelector(".show_external_trend")
                .classList.toggle("show_external_trend_active");
              document.querySelector(".show_tagId").innerHTML = "62";
              document.querySelector(".show_tagName").innerHTML = tagName;

              const popupRect = popup.getBoundingClientRect();
              const viewportWidth = window.innerWidth;
              const viewportHeight = window.innerHeight;

              let newX = clientX;
              let newY = clientY;

              if (newX + popupRect.width > viewportWidth) {
                newX = viewportWidth - popupRect.width;
              }

              if (newY + popupRect.height > viewportHeight) {
                newY = viewportHeight - popupRect.height;
              }

              if (newX < 0) {
                newX = 0;
              }

              if (newY < 0) {
                newY = 0;
              }

              popup.style.left = `${newX}px`;
              popup.style.top = `${newY}px`;
            }}
            className="depo1"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                style={{
                  position: "relative",
                  fontWeight: "600",
                  fontSize: "larger",
                  color: "rgb(50,50,50)",
                  bottom: "10px",
                  width: "100px",
                  height: "30px",
                  right: "-10%",
                }}
                className="sr-only"
              >
                Depo 1
              </span>
            </div>

            <img src={su_tank} alt="" />
          </div> */}
        </div>
      </section>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    su_depos: state.project_reducer.water_storage,
    tag_list: state.project_reducer.tag_list,
  };
};

export default connect(MapStateToProps)(Su_Depoları);
